export const firebaseWebConfig = {
    apiKey: 'AIzaSyBIhlBgUwwTqv41oYSl-UXczJUUDpq9nCs',
    authDomain: 'wasel-77d17.firebaseapp.com',
    projectId: 'wasel-77d17',
    storageBucket: 'wasel-77d17.firebasestorage.app',
    messagingSenderId: '999463563878',
    appId: '1:999463563878:web:3488f454551fe53f47b3a7',
    measurementId: 'G-VWNQ5L8JV9',
};

export const firebaseWebPushVapidKey =
    process.env.REACT_APP_FIREBASE_VAPID_KEY ||
    'BFkvOXWwlnMfsqtpTxNL1-wfgQNv1cZflk0m9vKPWu6fjTafQ9FjB0LAO2dVuzQROka7DHoiMFLWi_aVXAFOKFU';
